<template>
  <RevContainer class="bg-surface-default-mid mb-56 md:mb-72">
    <div class="flex flex-col gap-56 pt-56 md:gap-72 md:pt-72">
      <CustomContent v-if="customContentFirst" v-bind="content.customContent" />

      <ArticleCardsCarousel
        v-if="relatedComparePages?.length"
        :articles="relatedComparePages"
        :title="i18n(translations.relatedComparePagesTitle)"
      />

      <FeaturedArticles
        v-if="content.featuredArticles?.length > 0"
        :articles="content.featuredArticles"
      />

      <CustomContent
        v-if="!customContentFirst"
        v-bind="content.customContent"
      />
      <Reassurance />
    </div>
  </RevContainer>
</template>

<script lang="ts" setup>
import type { ModelComparisonCategoryContent } from '@backmarket/http-api/src/api-specs-model-comparison/models/category-content'
import type { ArticleCard } from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCard.types'
import ArticleCardsCarousel from '@backmarket/nuxt-layer-cms/ArticleCard/ArticleCardsCarousel.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import CustomContent from '../CustomContent/CustomContent.vue'
import FeaturedArticles from '../FeaturedArticles/FeaturedArticles.vue'
import Reassurance from '../Reassurance/Reassurance.vue'

import translations from './AdditionalContent.translations'

defineProps<{
  content: ModelComparisonCategoryContent['content']
  customContentFirst: boolean
  relatedComparePages?: ArticleCard[]
}>()

const i18n = useI18n()
</script>
